import * as React from "react";
import Header from "./Header";
import ContractForm from "../contract/ContractForm";
import ContractNew from "../contract/ContractNew";
import ClosedContractList from "../contract/ClosedContractList";
import ContractList from "../contract/ContractList";
import ContractView from "../contract/ContractView";
import ContractAnnex from "../contract/ContractAnnex";
import ContractConsolidate from "../contract/ContractConsolidate";

export default function LayoutContracts({ list, view, annex, userType, consolidate, newContract }) {
  return (
    <>
      <Header />
      {list ? (
        userType === 'closed' ? (
          <ClosedContractList />
        ) : (
          <ContractList userType={userType} />
        )
      ) : (
        view ? (
          <ContractView />
        ) : (
          annex ? (
            <ContractAnnex />
          ) : (
            consolidate ? (
              <ContractConsolidate />
            ) : (
              // /contracts/new lleva el selector de tipo de persona;
              // /contracts/:contractId edita el contrato natural directamente.
              newContract ? (
                <ContractNew />
              ) : (
                <ContractForm />
              )
            )
          )
        )
      )}
    </>
  );
}
